import { Box, styled } from '@mui/material';
import { SCHEDULE_COMPONENT_SCREEN_BORDER_WIDTH } from 'src/constants';

export const GridContainer = styled(Box)`
  align-items: center;
  direction: row;
  width: fit-content;
  justify-content: center;
  margin: auto;
  border: ${SCHEDULE_COMPONENT_SCREEN_BORDER_WIDTH}px solid black;
`;

export const DisclaimerBox = styled(Box)(
  ({ theme, height, width, $sectionFontSize }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${$sectionFontSize ?? 18}px;
    
    width: ${width}px;
    height: ${height}px;
  
    background-color: ${theme.palette.brand.lightGreen};
  `,
);

export const DisclaimerContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`;
